import * as Yup from "yup";
const classSchema = Yup.object({
  courseNumber: Yup.string()
    .max(10, "Course code must be at most 10 characters.")
    .required("Required*"),
  courseName: Yup.string()
    .max(32, "Course name must be at most 32 characters.")
    .required("Required*"),

  // startDate: Yup.date().required("Required*").min(new Date()),
  // endDate: Yup.date().required("Required*").min(new Date()),
});
export default classSchema;
